import React, { useEffect, useState } from 'react';
import { render, createPortal } from 'react-dom';
import { render as renderUI } from '@mybricks/render-web';
import { back, getParams, login, openPage, share, yodaShare } from './env';
import { ajax, callService, callConnector, getRemoveNodeIdsByCrowd, getUrlParams } from './ajax';
import coreLib from '@mybricks/comlib-core';
import { getIdcAvailUrl } from './cdn';
import { checkAllImags, useDomObserver } from './domObserver';
import { debounce } from 'lodash-es';
declare global {
  interface Window {
    __env_type_: string;
    __file_id_: number;
    __kpn_: string;
    __project_json_: {
      crowdList: { crowdId: string; nodeId: string }[];
      runtimePages: any;
      shareConfig: any;
      openShare: boolean;
      uri: string;
      title: string;
      serviceTemplate: {
        prt: { domain: string; laneId: string };
        staging: { domain: string; laneId: string };
      };
    };
    __com_defs_: {
      namespace: string;
      version: string;
      runtime: Function;
    }[];
  }
}

// 兼容云组件
const regAry = (comAray, comDefs) => {
  comAray.forEach((comDef) => {
    if (comDef.comAray) {
      regAry(comDef.comAray, comDefs);
    } else {
      comDefs[`${comDef.namespace}-${comDef.version}`] = comDef;
    }
  });
};
regAry(coreLib.comAray, window.__com_defs_);
window.allLibs = {
  comAray: Object.values(window.__com_defs_),
};

const projectJson = window.__project_json_;
const weblog = window.weblog;
const Yoda = window.Yoda;

const events = [
  {
    type: 'jump',
    title: '跳转',
    exe({ options }) {
      let handledUrl = getIdcAvailUrl(options.url);
      openPage(handledUrl, env.yoda, true);
    },
    options: [
      {
        id: 'url',
        title: '地址',
        editor: 'textarea',
      },
    ],
  },
  {
    type: 'back',
    title: '返回上一级',
    exe() {
      back(env.yoda);
    },
  },
  {
    type: 'share',
    title: '分享',
    exe() {
      share(env, void 0, {}, () => { });
    },
  },
];

const env = {
  renderCom(json, opts, coms) {
    return new Promise((resolve) => {
      resolve(
        renderUI(json, {
          comDefs: { ...coms, ...window.__com_defs_ },
          ...(opts || {}),
          observable: window.rxui.observable,
        }),
      );
    });
  },
  events,
  pageType: 'H5',
  weblog: weblog,
  get yoda() {
    return Yoda;
  },
  get projectId() {
    return window.__file_id_;
  },
  getPageCode() {
    let uri = window.__project_json_.uri;
    return `OP_ACTIVITY_FZ_${uri.split('/').pop()}`;
  },
  get params() {
    return getParams();
  },
  createPortal(children) {
    return createPortal(children, document.body);
  },
  openPage,
  back,
  share,
  login,
  ajax,
  callService,
  callConnector,
  kwai: {
    share(shareParams: any, cb: any, extraLogInfo?: Record<string, any>) {
      return yodaShare(Yoda, projectJson.shareConfig, projectJson.openShare, shareParams, cb, extraLogInfo);
    },
  },
  lazyLoadImage: debounce(checkAllImags, 10),
  showErrorNotification: false,
};

function hideLoadingPage() {
  const loadingDom = document.querySelector('#loading');
  if (loadingDom) {
    loadingDom.style.display = 'none';
  }
}

function isYodaEnv() {
  return /yoda|kwai|kuaishou/i.test(navigator.userAgent) || window.__yodaBridge__ !== undefined || /kwailive:\/\/webview|yoda_/.test(location.href);
}
function lostYodaCookie() {
  return typeof window !== 'undefined' && !document.cookie.includes('kpn=');
}

projectJson.crowdList = (projectJson.crowdList || []).filter((item) => item.crowdId && item.nodeId);
function Page() {
  const [pageLoading, setPageLoading] = useState(!!projectJson.crowdList.length);
  const queryParams: any = getUrlParams();

  useEffect(() => {
    // 静态页兜底打点
    const fmpCustomTime = Date.now();
    window._fmpTimerId = setTimeout(() => {
      if (window.renderStartTime) {
        weblog.fmp(window.renderStartTime);
        console.log('兜底上报fmp', window.renderStartTime);
      } else {
        weblog.fmp(fmpCustomTime);
      }
      clearTimeout(window._fmpTimerId);
      window._fmpTimerId = null;
      console.log('fmp trigger in didmount');
    }, 2500);

    // 人群配置
    if (pageLoading) {
      getRemoveNodeIdsByCrowd(projectJson.crowdList).then((nodeIds) => {
        projectJson.runtimePages.slot.comAry = projectJson.runtimePages.slot.comAry.filter(
          (node) => nodeIds.indexOf(node.id) === -1,
        );
        setPageLoading(false);
      });
    }
  }, []);

  useEffect(() => {
    if (pageLoading === false) {
      hideLoadingPage();
    }
  }, [pageLoading]);

  useEffect(() => {
    try {
      if (isYodaEnv() && lostYodaCookie()) {
        weblog?.plugins?.radar?.event({
          extra_info: {
            text: 'yoda容器缺少cookie',
            href: window.location.href, // 添加当前页面的 URL
          },
          name: 'yodaWebViewCookieMissed',
        });
      }
      if (isYodaEnv() && lostYodaCookie() && !queryParams.lostCookieFlg) {
        setTimeout(() => {
          weblog?.plugins?.radar?.event({
            extra_info: {
              text: 'yoda容器缺少cookie，并且重定向到别的页面',
              href: window.location.href, // 添加当前页面的 URL
              userAgent: navigator.userAgent,
              inYodaBridge: window.__yodaBridge__ !== undefined
            },
            name: 'yodaWebViewCookieMissedReloadPage',
          });
        }, 0)
        setTimeout(() => {
          window.location.replace(`${location.href}&lostCookieFlg=1`)
        }, 200)
      }
    } catch (e) {
      console.log(e, 'yoda环境检测错误')
    }
  }, [])

  useDomObserver();

  if (pageLoading) {
    return;
  } else {
    return renderUI(projectJson.runtimePages, {
      showErrorNotification: false,
      comDefs: window.__com_defs_,
      env,
      events,
      observable: window.rxui.observable,
      errorHandler(error, reactErrorInfo) {
        console.log('==错误拦截==', {
          error,
          reactErrorInfo
        })
        weblog?.plugins?.radar?.event({
          name: '全局异常',
          extra_info: {
            text: '全局异常',
            error,
            reactErrorInfo,
          }
        });
      }
    });
  }
}

const ua = navigator.userAgent;
let isMobile = false;
if (ua) {
  isMobile = /(iPhone|iPod|iPad|Android|ios)/i.test(ua) || /AppleWebKit.*Mobile.*/i.test(ua);
}
const searchParams = new URL(location.href).searchParams;

function ReloadPage() {
  return renderUI(window.__project_json_.runtimePages, {
      showErrorNotification: false,
      comDefs: window.__com_defs_,
      env,
      events,
      observable: window.rxui.observable,
      errorHandler(error, reactErrorInfo) {
        console.log('==错误拦截==', {
          error,
          reactErrorInfo
        })
        weblog?.plugins?.radar?.event({
          name: '全局异常',
          extra_info: {
            text: '全局异常',
            error,
            reactErrorInfo,
          }
        });
      }
    });
}

// 重新渲染页面
window.reRenderPage = function () {
  if (isMobile || searchParams.get('isPc')) {
    window.rxui.render(<ReloadPage />, document.querySelector('#appview'));
  }
};

// pc上使用iframe渲染并展示二维码

if (isMobile || searchParams.get('isPc')) {
  window.rxui.render(<Page />, document.querySelector('#appview'));
} else {
  document.querySelector('#appview').style.backgroundColor = '#ffffff';
  const QRCode = () => {
    useEffect(() => {
      const script = document.createElement('script');

      script.src = 'https://f2.eckwai.com/udata/pkg/eshop/fangzhou/pub/pkg/qrcode/qrcode.js';
      script.onload = () => {
        window.QRCode.toCanvas(
          document.getElementById('preview-qrcode'),
          `${location.href}${location.search ? '&' : '?'}layoutType=4`,
          {
            height: 150,
            width: 150,
          },
          function (error) {
            if (error) console.error(error);
          },
        );
      };
      document.body.appendChild(script);
    }, []);
    return (
      <div
        style={{
          width: '100%',
          maxWidth: 280,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
          marginLeft: 10,
        }}
      >
        <div style={{ marginTop: 10 }}>
          <div style={{ textAlign: 'center' }}>建议使用快手APP扫码预览</div>
        </div>
        <div style={{ width: 150, height: 150, display: 'flex', justifyContent: 'center', position: 'relative' }}>
          <div
            style={{
              width: 20,
              height: 20,
              left: '50%',
              top: '50%',
              transform: 'translate(-50%, -50%)',
              position: 'absolute',
              backgroundSize: 'contain',
              backgroundImage:
                'url(https://f2.eckwai.com/udata/pkg/eshop/fangzhou/images/kwai_icon.c84a6252fe8e3e37.png)',
            }}
          ></div>
          <canvas id="preview-qrcode" />
        </div>
      </div>
    );
  };

  render(
    <div
      style={{
        display: 'flex',
        maxWidth: 900,
        width: '100%',
        height: '100vh',
        position: 'absolute',
        left: '50%',
        transform: 'translateX(-50%)',
        marginLeft: 140,
      }}
    >
      <iframe
        src={location.href + `${location.search ? '&' : '?'}isPc=1`}
        style={{
          borderWidth: 0,
          width: '100%',
          maxWidth: '640',
          height: '100%',
          boxShadow: '0 2px 6px #aaa',
        }}
      ></iframe>
      <QRCode />
    </div>,
    document.querySelector('#appview'),
  );
  hideLoadingPage();
}
